<template>
  <div>
    <Header></Header>
    <race-form></race-form>
  </div>
</template>

<script>
import Header from "@/components/dashboard/Header";
import RaceForm from "@/components/RaceForm";

export default {
  data() {
    return {
      name: null,
      mobile: null ,
      email: null,
      username: null,
      password: null,
    };
  },
  components: {
    Header,
    RaceForm
  }
};
</script>

<style scoped>
</style>
